import { HorizontalSafeAreaContainer } from '../../../../components';
import { GroupOrderSetupScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <GroupOrderSetupScreen />
    </HorizontalSafeAreaContainer>
  );
}
